const MILES_PER_PERCENT = 0.141;
const MILES_PER_PERCENT_BOLT = 0.25;

export default function batteryToMiles(battery, vehicleModel) {
  if (vehicleModel === 'bolt' || vehicleModel === 'bchariot') {
    return (battery * MILES_PER_PERCENT_BOLT).toFixed();
  }

  return (battery * MILES_PER_PERCENT).toFixed();
}